<script setup lang="ts">
import { useAuthStore } from '@/stores/auth'
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
const { login } = useAuthStore()
const router = useRouter()

onMounted(async () => {
  try {
    const hash = window.location.hash

    if (hash.includes('access_token')) {
      const accessToken = hash.split('access_token=')[1].split('&')[0]
      const signupRequest = await login({
        socialKey: accessToken,
        socialType: 'NAVER',
      })

      if (signupRequest.redirect) {
        router.push({
          path: signupRequest.redirect,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          state: { signupRequest: signupRequest as Record<string, any> },
        })
      } else {
        router.push('/')
      }
    }
  } catch (e) {
    if (e instanceof Error) {
      alert(e.message)
      router.push('/login')
    }
    console.error(e)
  }
})
</script>

<template>
  <div></div>
</template>
